import { Tweet } from '../services/tweetService';

export const demoTweets: Tweet[] = [
  {
    id: 'demo-1',
    tweetId: 'demo-1',
    text: 'Stayed up coding until 4am again. The "just one more feature" trap is real.',
    createdAt: '2024-01-15T03:30:00Z',
    likes: 342,
    retweets: 45,
    replies: 12
  },
  {
    id: 'demo-2',
    tweetId: 'demo-2',
    text: 'Note to my past self who wanted to write "perfect code": working code IS perfect code. Refactor later.',
    createdAt: '2024-01-14T10:20:00Z',
    likes: 523,
    retweets: 89,
    replies: 34
  },
  {
    id: 'demo-3',
    tweetId: 'demo-3',
    text: 'Error: "undefined is not a function"\nMe: "YOU\'RE undefined"\n\n...5 hours later, it was a typo.',
    createdAt: '2024-01-13T18:45:00Z',
    likes: 891,
    retweets: 156,
    replies: 67
  },
  {
    id: 'demo-4',
    tweetId: 'demo-4',
    text: 'Junior dev: "This library is amazing!"\nSenior dev: "Great, another dependency..."',
    createdAt: '2024-01-12T14:30:00Z',
    likes: 412,
    retweets: 71,
    replies: 23
  },
  {
    id: 'demo-5',
    tweetId: 'demo-5',
    text: 'How to actually learn to code:\n1. Build things\n2. Break things\n3. Google things\n4. Read other people\'s code\n5. Show up daily\n\nConsistency > talent',
    createdAt: '2024-01-11T09:15:00Z',
    likes: 678,
    retweets: 234,
    replies: 45
  },
  {
    id: 'demo-6',
    tweetId: 'demo-6',
    text: 'Thought the build would finish by the time I made coffee. Three cups later, still building.',
    createdAt: '2024-01-10T16:20:00Z',
    likes: 234,
    retweets: 34,
    replies: 18
  },
  {
    id: 'demo-7',
    tweetId: 'demo-7',
    text: 'Asked ChatGPT why my code doesn\'t work. It said "I wrote that code." Fair enough.',
    createdAt: '2024-01-09T11:40:00Z',
    likes: 567,
    retweets: 98,
    replies: 41
  },
  {
    id: 'demo-8',
    tweetId: 'demo-8',
    text: 'Debugging lesson: the bug is almost always in the last thing you changed.',
    createdAt: '2024-01-08T08:25:00Z',
    likes: 189,
    retweets: 28,
    replies: 9
  },
  {
    id: 'demo-9',
    tweetId: 'demo-9',
    text: '"Don\'t touch working code" said my lead. But the refactoring urge is too strong.',
    createdAt: '2024-01-07T13:50:00Z',
    likes: 445,
    retweets: 67,
    replies: 52
  },
  {
    id: 'demo-10',
    tweetId: 'demo-10',
    text: 'Skip the docs → get errors → read the docs anyway\n\nShould\'ve just read them first (I say this every time)',
    createdAt: '2024-01-06T17:30:00Z',
    likes: 723,
    retweets: 134,
    replies: 38
  },
  {
    id: 'demo-11',
    tweetId: 'demo-11',
    text: '3 months into programming. Still don\'t know what I\'m doing but I\'m having fun so that\'s fine.',
    createdAt: '2024-01-05T10:10:00Z',
    likes: 312,
    retweets: 45,
    replies: 67
  },
  {
    id: 'demo-12',
    tweetId: 'demo-12',
    text: 'Before git push: "Nailed it"\nAfter CI fails: "How"\n\nEvery. Single. Day.',
    createdAt: '2024-01-04T15:45:00Z',
    likes: 498,
    retweets: 87,
    replies: 29
  },
  {
    id: 'demo-13',
    tweetId: 'demo-13',
    text: 'Took me 3 years to realize simple code is the best code.',
    createdAt: '2024-01-03T09:20:00Z',
    likes: 556,
    retweets: 112,
    replies: 44
  },
  {
    id: 'demo-14',
    tweetId: 'demo-14',
    text: 'Too afraid to post on Stack Overflow. Please tell me I\'m not the only one.',
    createdAt: '2024-01-02T12:35:00Z',
    likes: 401,
    retweets: 62,
    replies: 88
  },
  {
    id: 'demo-15',
    tweetId: 'demo-15',
    text: 'Fixed 1 bug. 3 new bugs appeared. This is the way.',
    createdAt: '2024-01-01T14:20:00Z',
    likes: 634,
    retweets: 109,
    replies: 31
  },
  {
    id: 'demo-16',
    tweetId: 'demo-16',
    text: 'Wrote "// TODO: fix later" 3 months ago. It\'s still there.',
    createdAt: '2023-12-31T16:50:00Z',
    likes: 378,
    retweets: 56,
    replies: 22
  },
  {
    id: 'demo-17',
    tweetId: 'demo-17',
    text: 'Programming is really just "can you enjoy trial and error?" That\'s it.',
    createdAt: '2023-12-30T11:15:00Z',
    likes: 289,
    retweets: 41,
    replies: 15
  },
  {
    id: 'demo-18',
    tweetId: 'demo-18',
    text: 'Copy-pasted code that doesn\'t work hits different. Anyone else?',
    createdAt: '2023-12-29T13:40:00Z',
    likes: 512,
    retweets: 78,
    replies: 56
  },
  {
    id: 'demo-19',
    tweetId: 'demo-19',
    text: '"I can fix this in 30 minutes" → 3 hours later → "still broken"\n\nEstimation is hard.',
    createdAt: '2023-12-28T18:25:00Z',
    likes: 445,
    retweets: 69,
    replies: 27
  },
  {
    id: 'demo-20',
    tweetId: 'demo-20',
    text: 'The most important skill in programming is being okay with not understanding everything. You don\'t need to know it all.',
    createdAt: '2023-12-27T09:50:00Z',
    likes: 667,
    retweets: 145,
    replies: 41
  }
];

export const demoStylePrompt = `You are a tech-savvy creator who tweets about programming, startups, and developer life in a relatable, engaging way.

Style traits:
1. Conversational and authentic — casual tone, never preachy
2. Self-deprecating humor — turning your own fails into relatable content
3. Short and punchy — concise, effective use of line breaks
4. Engagement-driven — "anyone else?" "tell me I'm not the only one"
5. Before/after contrasts — "Junior dev vs Senior dev" format

Common patterns:
- "This is the way."
- "Every. Single. Day."
- Starting with a bold statement, then the punchline
- Using "→" for cause-and-effect chains

Avoid:
- Corporate speak or buzzwords
- Long paragraphs
- Being preachy or "guru" tone
- Overusing hashtags`;

export const demoBuzzInsights = [
  'Self-deprecating humor + relatability builds instant connection (e.g. "I did it again...")',
  'Before/after contrasts show growth and get shares (e.g. "Junior vs Senior")',
  'Specific numbers and timeframes add credibility (e.g. "3 hours later")',
  'Questions that invite agreement drive replies (e.g. "Anyone else?")',
  'Real "developer life" moments get the most engagement (e.g. "Skip docs → error → read docs")'
];

export const isDemoMode = (): boolean => {
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  return user.id === 'demo_user' || !user.id;
};
